import getSupplierAddress from 'utils/print/getSupplierAddress';
import getSupplierCity from 'utils/print/getSupplierCity';
import getSupplierState from 'utils/print/getSupplierState';
import getSupplierZip from 'utils/print/getSupplierZip';

const getSupplierFullAddress = ({ value, ...otherProps }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const address = getSupplierAddress(otherProps);
  const city = getSupplierCity(otherProps);
  const state = getSupplierState(otherProps);
  const zip = getSupplierZip(otherProps);

  if (address && city && zip) {
    return `${address}, ${city}, ${state || ''} ${zip}`;
  }

  return null;
};

export default getSupplierFullAddress;



// WEBPACK FOOTER //
// ./src/utils/print/getSupplierFullAddress.js